import PortalVue from 'portal-vue';
import Vue from 'vue';

export default (vue?: typeof Vue) => {
	(vue || Vue).use(PortalVue);
	return {};
};
